<ng-container>
  <div class="page-title">
    <div [innerHTML]="'EmploymentInfo.Second.Title' | translate" class="title"></div>
    <div [innerHTML]="'EmploymentInfo.Second.SubTitle' | translate" class="sub-title"></div>
  </div>

  <app-employment
    (employmentModelChange)="updateUser()"
    [employmentModel]="user.secondHolder.employmentModel">
  </app-employment>
</ng-container>

<ng-container>
  <div *ngIf="isEmployed()" class="page-title">
    <div [innerHTML]="'EmploymentInfo.Second.CitizenshipTitle' | translate | safe:'html'" class="title"></div>
    <!--    <div class="sub-title" [innerHTML]="'EmploymentInfo.Second.CitizenshipSubTitle' | translate | safe:'html'"></div>-->
  </div>

  <app-employment-citizenship
    (employmentModelChange)="updateUser()"
    [addressModel]="user.secondHolder.addressModel"
    [employmentModel]="user.secondHolder.employmentModel">
  </app-employment-citizenship>
</ng-container>
